import { Box, CounterBadge, IconButton } from '@wix/design-system';
import { ChevronDownLarge, ChevronUpLarge } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectUnreadCount } from '../../../common/selectors/chat';
import { helpCenterService } from '../../../common/services/helpCenter';
import { classNames } from '../../../util';
import { isNumber } from '../../../util/guards';
import { Avatar } from './Avatar';
import { ChatbotToggleActions } from './ChatbotToggleActions';
import s from './styles.scss';
import { TitleContainer } from './TitleContainer';

export type ChatbotToggleProps = {
  expanded: boolean;
  onToggle: () => void;
};

export const ChatbotToggle: FC<ChatbotToggleProps> = ({
  expanded,
  onToggle,
}) => {
  const unreadCount = useSelector(selectUnreadCount);
  const showCounter = isNumber(unreadCount) && unreadCount > 0;

  const chatbotToggleClasses = classNames([
    s.chatbotToggle,
    expanded && s.chatbotToggleExpanded,
  ]);

  return (
    <div className={helpCenterService.isFullWidth ? s.rootFullWidth : ''}>
      <Box
        className={chatbotToggleClasses}
        dataHook="chatbot-toggle__box"
        verticalAlign="middle"
        gap="12px"
      >
        <div className={s.avatarWrapper}>
          <Avatar />
          {showCounter && (
            <CounterBadge
              className={s.counterBadge}
              skin="danger"
              dataHook="chatbot-toggle__unread-count"
            >
              {unreadCount}
            </CounterBadge>
          )}
        </div>
        <Box className={s.titleContainer} direction="vertical">
          <TitleContainer expanded={expanded} />
        </Box>
        <ChatbotToggleActions expanded={expanded} />
        <IconButton skin="light" onClick={onToggle} dataHook="chatbot-toggle">
          {expanded ? <ChevronDownLarge /> : <ChevronUpLarge />}
        </IconButton>
      </Box>
    </div>
  );
};
